module.exports = __webpack_public_path__ + "static/img/cert-bg2.d18eb9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/oneHourCode/cert-bg2.png
// module id = Z8CB
// module chunks = 1